import React from 'react';
import { useLocation } from 'react-router-dom';
import Parser from 'html-react-parser';
import './styles.scss';
import l from '../../../lang';
import InfoIcon from '../../../assets/icons/info-unfilled.svg?url';
import { Routes } from '../../../config/routes';

const isPublicAuthPage = pathname => {
  if (pathname === Routes.LOGIN || pathname === Routes.SIGN_UP) {
    return true;
  }

  return pathname.startsWith('/plugin/signup');
};

const TestMessage = () => {
  const location = useLocation();

  if (import.meta.env.REACT_APP_ENV === 'production') {
    return <></>;
  }

  const messageKey = isPublicAuthPage(location.pathname)
    ? 'common.testMessage.authEntry'
    : 'common.testMessage';

  return (
    <div className="test-message">
      <div className="test-message__label">
        <span>{l('common.testMessage.label')}</span>
        <img src={InfoIcon} alt="" aria-hidden className="test-message__info-icon" />
      </div>
      <div className="test-message__text">{Parser(l(messageKey))}</div>
    </div>
  );
};

export default TestMessage;
